<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/login.png"
                alt="login"
                class="mx-auto"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">S'inscrire</h4>
                  <p>Bienvenue sur le dashboard Rankwell.</p>
                </div>

                <div>
                  <vs-input
                    name="email"
                    type="text"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="Email"
                    v-model="email"
                    class="w-full"
                  />

                  <vs-input
                    type="password"
                    name="password"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Mot de passe"
                    v-model="password"
                    class="w-full mt-6"
                  />
                  <div class="flex flex-wrap justify-between my-5">
                    <vs-alert
                      color="danger"
                      icon="new_releases"
                      v-if="hasError"
                    >
                      {{ error_msg }}
                    </vs-alert>
                    <vs-button color="primary" type="border hidden-btn">OK</vs-button>
                    <vs-button
                      color="primary"
                      class="float-right register-btn"
                      @click="register"
                      >S'inscrire</vs-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
	name: "register",
	data() {
		return {
			email: "",
			password: "",
			hasError: false,
			error_msg: ""
		};
	},
	methods: {
		/**
		 * Query the API to register or not the user
		 */
		register() {
			let api_log_url = this.$store.state.api_log_url;
			if(this.email == "" && this.password == "")
				return alert("Please fill in all fields");
			this.$http
				.post(api_log_url + "user/register", {
					email: this.email,
					password: this.password
				})
				.then(response => {
					if(response.data.auth) {
						sessionStorage.setItem("jwt", response.data.token);
						this.$router.push("/");
					}
					else{
						this.error = response.data.msg;
						this.hasError = true;
					}
				})
				.catch(err => {
					this.hasError = true;
					this.error = err;
				});
		}
	}
};
</script>

<style lang="scss">
#page-login {
  .hidden-btn {
    visibility: hidden;
  }
  .register-btn {
    margin-top: 10px;
  }
}
</style>
